import { Component, OnInit } from '@angular/core';
import { PrintPrinterItem, PrintReportItem, PrintService } from '@app/core/services/print.service';
import { CarrierItem, CarrierService } from '@app/services/carrier.service';
import { ModalService } from '@app/core/services/modal.service';

@Component({
    selector: 'tt-carriers',
    templateUrl: './carriers.component.html',
    styleUrls: ['./carriers.component.css'],
    standalone: false,
})
export class CarriersComponent implements OnInit {
    public carrierKeyno: string | number = 0;

    public reportKeyno: string | number = 0;

    public printerKeyno: string | number = 0;

    public quantity: string | number = 1;

    public carriers: CarrierItem[] = [];

    public printers: PrintPrinterItem[] = [];

    public reports: PrintReportItem[] = [];

    public printing = false;

    constructor(
        private modal: ModalService,
        private carrier: CarrierService,
        private print: PrintService
    ) {}

    public async printReports(): Promise<void> {
        try {
            this.printing = true;

            const response = await this.carrier.printLabels({
                carrier_keyno: this.carrierKeyno,
                report_keyno: this.reportKeyno,
                printer_keyno: this.printerKeyno,
                quantity: this.quantity,
            });

            if (response?.errorcode !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });
            }
        } finally {
            this.printing = false;
        }
    }

    public async ngOnInit(): Promise<void> {
        await Promise.all([
            this.carrier.getCarriers().then(items => this.carriers = items),
            this.print.getPrinters().then(items => this.printers = items),
            this.print.getReports().then(items => this.reports = items.filter(item => item.isActive === true && item.reportId.includes('NorcoCarriersLabel'))),
        ]);
    }
}
